// extracted by mini-css-extract-plugin
export default {"root":"m6hJj","wrap":"I2x2D","header":"_KFHC","logo":"CcIXm","title":"cEKH4"};